import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// PaymentContext removed - simplified tracking
import { addDatadogPageView } from "../../services/datadog";
import { PATH } from "../path";

export const getPageNameFromPath = (pathname: string): string => {
	switch (pathname) {
		case PATH.HOME:
			return "home";
		case PATH.SPLASH:
			return "splash";
		case PATH.LANDING:
			return "landing";
		case PATH.PRODUCT_LIST:
			return "product_list";
		case PATH.CART:
			return "cart";
		case PATH.PAYMENT:
			return "payment";
		case PATH.CASH_QR:
			return "cash_qr";
		case PATH.ORDER_CONFIRMATION:
			return "order_confirmation";
		case PATH.INFO:
			return "info";
		case PATH.ADMIN:
			return "admin";
		case PATH.MAINTENANCE:
			return "maintenance";
		case "/404":
			return "error_404";
		default:
			return "unknown";
	}
};

export const usePageViewTracking = () => {
	const location = useLocation();
	// Payment reference removed with PaymentContext

	useEffect(() => {
		const pageName = getPageNameFromPath(location.pathname);

		// Track page view with Datadog
		addDatadogPageView(pageName, undefined, {
			pathname: location.pathname,
			search: location.search,
			timestamp: new Date().toISOString(),
		});
	}, [location.pathname, location.search]);
};
